import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "../../../../lib/styled";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import { useTranslation } from "react-i18next";
import { useFeedbackBar } from "./useFeedbackBar";
import { FeedbackModal } from "../FeedbackModal";
import { gaps } from "../../../primitives/spacing";

interface FeedbackBarProps {
  claimId: string;
}

const FeedbackBarRoot = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

const ButtonRow = styled(Stack)({
  justifyContent: "center",
});

const FadedButton = styled(Button)<{ $faded: boolean }>(({ $faded }) => ({
  opacity: $faded ? 0.4 : 1,
  transition: "opacity 0.15s",
}));

export function FeedbackBar({ claimId }: FeedbackBarProps) {
  const { selected, select, modalOpen, onModalClose, onModalSubmit } = useFeedbackBar(claimId);
  const { t } = useTranslation();

  const positive = selected === 3;
  const negative = selected === 0;

  return (
    <>
      <FeedbackBarRoot gap={gaps.snug}>
        <Typography variant="body2" color="text.secondary">
          {t("feedback.prompt")}
        </Typography>
        <ButtonRow direction="row" gap={gaps.snug}>
          <FadedButton
            variant={positive ? "contained" : "outlined"}
            color="primary"
            startIcon={<ThumbUpAltOutlinedIcon />}
            onClick={() => select(3)}
            $faded={negative}
          >
            {t("feedback.helpful")}
          </FadedButton>
          <FadedButton
            variant={negative ? "contained" : "outlined"}
            color="primary"
            startIcon={<ThumbDownAltOutlinedIcon />}
            onClick={() => select(0)}
            $faded={positive}
          >
            {t("feedback.notHelpful")}
          </FadedButton>
        </ButtonRow>
      </FeedbackBarRoot>

      <FeedbackModal open={modalOpen} onClose={onModalClose} onSubmit={onModalSubmit} />
    </>
  );
}
